import { useEffect, useState } from 'react'
import BaseTable from '@Components/table/BaseTable/BaseTable'
import { ICommonQuery, IMetaData, ITableHeaders } from '@Models/common.model'
import * as Redux from 'redux'
import { connect } from 'react-redux'
import EducatorInfoActions from '@Stores/educator/actions/educator-info.action'
import BasePagination, {
    IBasePaginationEvent,
} from '@Components/table/BasePagination/BasePagination'
import { CommonService } from '@Services/common.service'
import { APIServices } from '@Services/api.service'
import AuthAction from '@Stores/auth/auth.action'
import DetailReportModal from './detailReportModal'

const headers: ITableHeaders[] = [
    {
        name: 'Date',
        key: 'createDate',
        formatType: 'date',
    },
    {
        name: 'Reference',
        key: 'reference',
    },
    {
        name: 'Days Open',
        key: 'daysOpen',
    },
    {
        name: 'DEPT. Code',
        key: 'deptCode',
    },
    {
        name: 'Firearm',
        key: 'firearm',
    },
    {
        name: 'Action',
        key: 'action',
    },
    {
        name: 'Status',
        key: 'status',
    },
    {
        name: 'Date Close',
        key: 'dateClosed',
    },
]

const dummyData = [
    {
        date: '05/05/2020',
        reference: '1568-6966',
        daysOpen: ' 5',
        deptCode: 'SS-Stockton',
        action: 'REMOVAL-BLOCK',
        status: 'CLOSED',
        dataClosed: '06/06/2020',
    },
]
interface IReportInfoProps {
    educators?: any[]
    getList?: () => void
    metadata: IMetaData
    setQueries: (params: ICommonQuery) => void
    getDetail?: (id: string) => void
    educatorDetail?: any
    getPublicToken: () => Promise<any>
    getAuthorization: () => Promise<any>
    publicToken: string
}
function ReportInfo(props: IReportInfoProps) {
    const {
        educators,
        getList,
        metadata,
        setQueries,
        getDetail,
        educatorDetail,
        getAuthorization,
        getPublicToken,
        publicToken,
    } = props
    const [showModal, setShowModal] = useState(false)
    const [listDetailData, setListDetailData] = useState({})
    const [currentPage, setCurrentPage] = useState(1)

    const onGetDetail = (e: any) => {
        setShowModal(true)
        setListDetailData(e?.data)
        if (getDetail) getDetail(e?.data?.id)
    }

    useEffect(() => {
        if (publicToken) {
            if (setQueries) setQueries({ limit: 10, offset: 0 })
            if (getList) getList()
        } else {
            getAuthorization().then(() => {
                getPublicToken().then(() => {
                    if (setQueries) setQueries({ limit: 10, offset: 0 })
                    if (getList) getList()
                })
            })
        }
        return () => {
            APIServices.axiosCancelToken()
        }
    }, [])

    const handlePageChange = (evt: IBasePaginationEvent) => {
        const { offset, limit } = evt
        if (setQueries) setQueries({ limit, offset })
        if (getList) getList()
    }

    const dataList = educators?.map((item: any) => {
        return {
            id: item?.id,
            createDate: item?.createdAt,
            reference: item?.code,
            daysOpen: item?.dayOpen,
            deptCode: item?.deptCode,
            action: 'Pending',
            status: CommonService.textCapitalize(item?.status),
            dateClosed: '-',
            firearm: `${
                item?.itemAmount ? `${item?.itemAmount} firearm(s)` : '-'
            }`,
        }
    })

    return (
        <>
            <div className="px-4">
                <p>SFP INSTANCE TRACKING</p>
                <BaseTable
                    headers={headers}
                    data={dataList}
                    metadata={metadata}
                    // isLoading={isLoading}
                    rowClickedAction={(e) => {
                        setShowModal(true)
                        onGetDetail(e)
                    }}
                />
                <BasePagination
                    currentPage={currentPage}
                    metadata={metadata}
                    pageChanged={handlePageChange}
                />
                <DetailReportModal
                    open={showModal}
                    onClose={() => setShowModal(false)}
                    listData={listDetailData}
                    detail={educatorDetail}
                />
            </div>
        </>
    )
}
const mapStateToProps = (store: any) => {
    const { educators, metadataEducators, educatorDetail } =
        store?.educator?.educatorInfo

    const publicToken = store?.auth?.publicToken
    return {
        educators,
        metadata: metadataEducators,
        educatorDetail,
        publicToken,
    }
}
const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    const { getPublicToken, getAuthorization } = AuthAction
    const { getEducatorInfo, setEducatorQueries, getEducatorDetail } =
        EducatorInfoActions
    return {
        getList: () => dispatch(getEducatorInfo() as any),
        setQueries: (params: ICommonQuery) =>
            dispatch(setEducatorQueries(params) as any),
        getDetail: (id: string) => {
            dispatch(getEducatorDetail(id) as any)
        },
        getPublicToken: () => dispatch(getPublicToken() as any),
        getAuthorization: () => dispatch(getAuthorization() as any),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ReportInfo)
